/**
 * Keyboard key code supported by the Keyboard module.
 * This is a partial list taken from https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code/code_values/.
 * Only the Chrome/Firefox supported keys have been listed, but others may be available depending on platform.
 */
export enum Key
{
    Escape = "Escape",
    Digit0 = "Digit0",
    Digit1 = "Digit1",
    Digit2 = "Digit2",
    Digit3 = "Digit3",
    Digit4 = "Digit4",
    Digit5 = "Digit5",
    Digit6 = "Digit6",
    Digit7 = "Digit7",
    Digit8 = "Digit8",
    Digit9 = "Digit9",
    Minus = "Minus",
    Equal = "Equal",
    Backspace = "Backspace",
    Tab = "Tab",
    KeyQ = "KeyQ",
    KeyW = "KeyW",
    KeyE = "KeyE",
    KeyR = "KeyR",
    KeyT = "KeyT",
    KeyY = "KeyY",
    KeyU = "KeyU",
    KeyI = "KeyI",
    KeyO = "KeyO",
    KeyP = "KeyP",
    BracketLeft = "BracketLeft",
    BracketRight = "BracketRight",
    Enter = "Enter",
    ControlLeft = "ControlLeft",
    KeyA = "KeyA",
    KeyS = "KeyS",
    KeyD = "KeyD",
    KeyF = "KeyF",
    KeyG = "KeyG",
    KeyH = "KeyH",
    KeyJ = "KeyJ",
    KeyK = "KeyK",
    KeyL = "KeyL",
    Semicolon = "Semicolon",
    Quote = "Quote",
    Backquote = "Backquote",
    ShiftLeft = "ShiftLeft",
    Backslash = "Backslash",
    KeyZ = "KeyZ",
    KeyX = "KeyX",
    KeyC = "KeyC",
    KeyV = "KeyV",
    KeyB = "KeyB",
    KeyN = "KeyN",
    KeyM = "KeyM",
    Comma = "Comma",
    Period = "Period",
    Slash = "Slash",
    ShiftRight = "ShiftRight",
    NumpadMultiply = "NumpadMultiply",
    AltLeft = "AltLeft",
    Space = "Space",
    CapsLock = "CapsLock",
    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
    F5 = "F5",
    F6 = "F6",
    F7 = "F7",
    F8 = "F8",
    F9 = "F9",
    F10 = "F10",
    ScrollLock = "ScrollLock",
    Numpad7 = "Numpad7",
    Numpad8 = "Numpad8",
    Numpad9 = "Numpad9",
    NumpadSubtract = "NumpadSubtract",
    Numpad4 = "Numpad4",
    Numpad5 = "Numpad5",
    Numpad6 = "Numpad6",
    NumpadAdd = "NumpadAdd",
    Numpad1 = "Numpad1",
    Numpad2 = "Numpad2",
    Numpad3 = "Numpad3",
    Numpad0 = "Numpad0",
    NumpadDecimal = "NumpadDecimal",
    IntlBackslash = "IntlBackslash",
    F11 = "F11",
    F12 = "F12",
    IntlYen = "IntlYen",
    MediaTrackPrevious = "MediaTrackPrevious",
    MediaTrackNext = "MediaTrackNext",
    NumpadEnter = "NumpadEnter",
    ControlRight = "ControlRight",
    AudioVolumeMute = "AudioVolumeMute",
    MediaPlayPause = "MediaPlayPause",
    MediaStop = "MediaStop",
    BrowserHome = "BrowserHome",
    NumpadDivide = "NumpadDivide",
    PrintScreen = "PrintScreen",
    AltRight = "AltRight",
    NumLock = "NumLock",
    Pause = "Pause",
    Home = "Home",
    ArrowUp = "ArrowUp",
    PageUp = "PageUp",
    ArrowLeft = "ArrowLeft",
    ArrowRight = "ArrowRight",
    End = "End",
    ArrowDown = "ArrowDown",
    PageDown = "PageDown",
    Insert = "Insert",
    Delete = "Delete",
    ContextMenu = "ContextMenu",
    BrowserSearch = "BrowserSearch",
    BrowserFavorites = "BrowserFavorites",
    BrowserRefresh = "BrowserRefresh",
    BrowserStop = "BrowserStop",
    BrowserForward = "BrowserForward",
    BrowserBack = "BrowserBack",
}
